﻿export default function MarvlisApiProxy() {
    var self = this;

    self.proxyUrl = (url) => {
        if (url && url.toLowerCase().startsWith('api')) url = '/web/' + url;
        return `${url}`
    };
    self.usePascalCase = true;

    self.getHeaders = function () {
        let h = {};
        if (self.usePascalCase) h["X-JsonResponseCase"] = "Pascal";
        return h;
    }

    /**
    * Load data from the server using a HTTP GET request.
    * @param url A string containing the URL to which the request is sent.
    */
    self.get = function (url) {
        return $.ajax({
            url: self.proxyUrl(url),
            headers: self.getHeaders(),
            type: 'GET'
        });
    }; 

    self.delete = function (url) {
        return $.ajax({
            url: self.proxyUrl(url),
            headers: self.getHeaders(),
            type: 'DELETE'
        });
    }

    /**
    * Load data from the server using a HTTP POST request.
    * @param url A string containing the URL to which the request is sent.
    * @param data A plain object or string that is sent to the server with the request.
    */
    self.post = function (url, data) {
        return $.ajax({
            url: self.proxyUrl(url),
            headers: self.getHeaders(),
            contentType: "application/json",
            data: JSON.stringify(data),
            dataType: "json",
            type: 'POST'
        });
    };

    self.ajax = function (data) {
        data.url = self.proxyUrl(data.url);

        if (self.usePascalCase) {
            if (self.headers) {
                self.headers["X-JsonResponseCase"] = "Pascal";
            } else {
                self.headers = self.getHeaders();
            }
        }

        $.ajax(data);
    }

    self.reauthenticate = function () {
        return $.get(self.proxyUrl("auth"));
    };

    self.setSignalRToken = function () {
        let token = document.cookie.split("; ").find((row) => row.startsWith("marvlis_access_token="))?.split("=")[1];
        if (token) {
            $.connection.hub.qs = "access_token=" + token;
        }
    }


    // signalR class will manage connecting and maintaining the connection, including 
    // reauthentication with API if neccessary
    self.signalR = {};

    self.signalR.reconnect = function (reauth) {
        let result = $.connection.hub.start();

        // start the hub
        result.fail(function () {
            // if the connection fails and we're supposed to reauthenticate, do so
            if (reauth) {
                self.reauthenticate().done(function () {
                    self.setSignalRToken();
                    // if reauthentication fails, retry the connection attempt
                    result = self.signalR.reconnect(false);
                })
            }
            else if (self.signalR.reconnectFailed) self.signalR.reconnectFailed();
        });

        return result;
    };

    self.signalR.start = function (callback) {
        var hubURI = window.marvlisApiUrl + 'signalr/hubs';
        $.getScript(hubURI, function () {
            self.setSignalRToken();

            // set the hub's URL for the connection
            $.connection.hub.url = window.marvlisApiUrl + 'signalr';
            //$.connection.hub.logging = true;

            if (self.signalR.defineMethods) self.signalR.defineMethods();

            $.connection.hub.stateChanged(function (change) {
                if (self.signalR.onStateChanged) self.signalR.onStateChanged(change);

                if (change.newState === $.signalR.connectionState.disconnected) {
                    setTimeout(function () {
                        self.signalR.reconnect(true);
                    }, 5000); // Restart connection after 5 seconds.
                }
            });

            let result = self.signalR.reconnect(true);
            if (callback) callback(result);
        });
    };

}

